import { render } from "./payment-icon.vue?vue&type=template&id=dd75d192"
import script from "./payment-icon.vue?vue&type=script&lang=js"
export * from "./payment-icon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__